import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { getProvisioningStatus, startProvisioning } from './api'
import { isProvisioningComplete, isProvisioningFailed } from './wizardSteps'

const POLL_INTERVAL_MS = 2_500

export function provisioningStatusQueryKey(tenantId: string) {
  return ['onboarding', 'provisioning', tenantId] as const
}

/**
 * Poll do status do provisioning. Para de repetir quando a saga chega num estado terminal
 * (Completed ou Failed) — o usuario decide se tenta de novo (retry explicito, nao automatico).
 */
export function useProvisioningStatus(tenantId: string | undefined) {
  return useQuery({
    queryKey: provisioningStatusQueryKey(tenantId ?? ''),
    queryFn: () => getProvisioningStatus(tenantId ?? ''),
    enabled: tenantId !== undefined,
    refetchInterval: (query) => {
      const data = query.state.data
      if (data === undefined) {
        return POLL_INTERVAL_MS
      }
      return isProvisioningComplete(data) || isProvisioningFailed(data) ? false : POLL_INTERVAL_MS
    },
  })
}

/** Inicia/retoma o provisioning. Idempotente por tenant no backend: seguro re-chamar num retry. */
export function useStartProvisioning(tenantId: string | undefined) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => startProvisioning(tenantId ?? ''),
    onSuccess: (status) => {
      if (tenantId !== undefined) {
        queryClient.setQueryData(provisioningStatusQueryKey(tenantId), status)
      }
    },
  })
}
